import { getCookie } from 'cookies-next'
import { distinctIdCookieKey } from '../../cookie-keys'

export function getDistinctId() {
  return getCookie(distinctIdCookieKey)?.toString()
}
